export const ALLIED_PROPOSAL_INFO_FORM_ID = 'allied-proposal-info-form';
